import { useCallback, useState } from 'react';
import { useInfiniteQuery } from 'react-query';
export function useInfiniteQueryWithCursorPagination(queryKey, queryFn, options) {
    var _a;
    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const { data, fetchNextPage, fetchPreviousPage, isFetchingNextPage, isLoading, } = useInfiniteQuery(queryKey, queryFn, Object.assign(Object.assign({}, options), { getNextPageParam: (lastPage) => lastPage.hasNextPage && lastPage.endCursor }));
    const handleCursorChange = useCallback((direction) => {
        var _a, _b;
        if (direction === 'next') {
            if (!((_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a[currentPageIndex + 1])) {
                fetchNextPage();
            }
            setCurrentPageIndex((prev) => prev + 1);
        }
        if (direction === 'prev') {
            if (!((_b = data === null || data === void 0 ? void 0 : data.pages) === null || _b === void 0 ? void 0 : _b[currentPageIndex - 1])) {
                fetchPreviousPage();
            }
            setCurrentPageIndex((prev) => prev - 1);
        }
    }, [
        fetchNextPage,
        fetchPreviousPage,
        setCurrentPageIndex,
        currentPageIndex,
        data === null || data === void 0 ? void 0 : data.pages,
    ]);
    const resetPagination = useCallback(() => setCurrentPageIndex(0), [setCurrentPageIndex]);
    const currentPage = (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a[currentPageIndex];
    const totalCount = (currentPage === null || currentPage === void 0 ? void 0 : currentPage.totalCount) || 0;
    const isFirstPage = currentPageIndex === 0;
    return {
        currentPage,
        handleCursorChange,
        isFirstPage,
        isLoading: isLoading || isFetchingNextPage,
        resetPagination,
        totalCount,
    };
}
//# sourceMappingURL=useInfiniteQueryWithCursorPagination.js.map